import axios from 'axios'

const DATA_JSON = `https://script.google.com/a/wonderwall.net/macros/s/AKfycbzDispksncsJOaO92dRrJTwW6AcEptME0Ujp5LE/exec`
const TREND_JSON = `https://script.google.com/macros/s/AKfycbz4xKhHQXOHgBovlHcjoaffJweFI6o3iOIvUywKoJhBcL6X5fci3LrtzT-7nmUBW5MzBQ/exec`

export let dataLabelText = []
export let trendLabelText = []

export const load5gDataJson = async function(preview=false, type='data') {
  let jsonUrl = ''
  if (type === 'data') {
    jsonUrl = DATA_JSON
  } else if (type === 'trend') {
    jsonUrl = TREND_JSON
  }
  const json = await axios.get(jsonUrl)

  // jsonを文字列化してparse
  let target = JSON.parse(JSON.stringify(json.data), replacer)

  if (type === 'data') {
    dataLabelText = target.splice(0, 1)[0]
  } else if (type === 'trend') {
    trendLabelText = target.splice(0, 1)[0]
  }

  if (preview === false) {
    target = target.filter(n => n.publish === true)
  }

  // 日付でソート（新しい順）
  target.sort((a,b) => {
    return (a.publishedDate > b.publishedDate) ? -1 : 1
  })

  return target
}

// replacer関数
const replacer = (key, value) => {
  if( key === 'type' || key === 'genre') {
    return (value.includes(',')) ? value.split(',') : [value]
  } else if (value.toString().substring(0,4) === 'http') {
    return new URL(value)
  } else if (key === 'publishedDate') {
    return (value !== '') ? new Date(value) : new Date('2022-01-01')
  } else if (key === 'prefCode') {
    return parseInt(value)
  } else if (key === 'coordinates') {
    const coordinates = value.split(',')
    const lat = Number(coordinates[0])
    const lon = Number(coordinates[1])
    return [lat,lon]
  }
  return value
}

/**
 * Contents: Google Spreadsheetから取得したコンテンツ情報をクラス化
 */
export class Contents {

  /**
   * Google Spreadsheetから取得したコンテンツ情報
   * @param {obj} datas JSONオブジェクト
   */
  constructor(datas) {
    this.datas = datas
  }

  /**
   * Uidでコンテンツ情報を検索
   * @param  {String} uid 情報ID
   * @param  {Bool} preview trueの場合はpublished未指定の情報も取得
   * @return {Contents} 検索結果のContentsオブジェクト
   */
  lookupByUid(uid) {
    const datas = this.datas.filter(n => n.uid === uid)
    return new Contents(datas)
  }

  /**
   * 事例タイプでコンテンツ情報を検索
   * @param  {Array<String>} types 事例タイプ
   * @param  {Bool} preview trueの場合はpublished未指定の情報も取得
   * @return {Contents} 検索結果のContentsオブジェクト
   */
  lookupByType(types) {
    if (types instanceof Array) {
      if (types.includes('ALL')) {
        return new Contents(this.datas)
      }

      const datas = types.map(type => {
        return this.datas.filter(n => n.type.includes(type))
      })
      return new Contents(datas[0])
    } else {
      return new Contents(this.datas)
    }
  }
  
  /**
   * 事例ジャンルでコンテンツ情報を検索
   * @param  {Array<String>} types 事例タイプ
   * @param  {Bool} preview trueの場合はpublished未指定の情報も取得
   * @return {Contents} 検索結果のContentsオブジェクト
   */
  lookupByGenre(genres) {
    if (genres instanceof Array) {
      let datas = []
      genres.map(genre => {
        return this.datas.map(n => {
          if (n.genre.includes(genre)) {
            return datas.push(n)
          }
          return
        }).filter(n => n)
      })
      return new Contents(datas)
    } else {
      return new Contents(this.datas)
    }
  }
  
  /**
   * 公開日付でコンテンツ情報を検索
   * @param  {String} ref 基準日（YYYY-MM-DD）
   * @param  {String} compare 比較演算子：'eq' === , 'ne' !== , 'lt' < , 'le' <= , 'gt' > , 'ge' >=
   * @param  {Bool} preview trueの場合はpublished未指定の情報も取得
   * @return {Contents} 検索結果のContentsオブジェクト
   */
  lookupByDate(ref,compare) {
    let refDate = new Date(ref)
    refDate.setHours(refDate.getHours() -9)
    
    let datas
    if (compare === 'eq' || compare === '') { // ===
      datas = this.datas.filter(n => n.publishedDate.valueOf() === refDate.valueOf())
    } else if (compare === 'ne') { // !==
      datas = this.datas.filter(n => n.publishedDate.valueOf() !== refDate.valueOf())
    } else if (compare === 'lt') { // <
      datas = this.datas.filter(n => n.publishedDate.valueOf() < refDate.valueOf())
    } else if (compare === 'le') { // <=
      datas = this.datas.filter(n => n.publishedDate.valueOf() <= refDate.valueOf())
    } else if (compare === 'gt') { // >
      datas = this.datas.filter(n => n.publishedDate.valueOf() > refDate.valueOf())
    } else if (compare === 'ge') { // >=
      datas = this.datas.filter(n => n.publishedDate.valueOf() >= refDate.valueOf())
    } else {
      return new Contents(this.datas)
    }
    
    if (datas.length > 0) {
      return new Contents(datas)
    } else {
      return new Contents(this.datas)
    }
  }

  /**
   * キーワード検索
   * @param  {Object.<{ands: Array, omits: Array}>} キーワード検索
   * @return {Contents} 検索結果のContentsオブジェクト
   */
    lookupByKeywords(kw) {
      if (kw instanceof Object) {
        let datas = this.datas
        let kwPosition = []
        const target = [
          'area',
          'copy',
          'mainOrg',
          'goal',
          'outcome',
          'overviewTask',
          'overviewTech',
          'relatedOrg',
          'theme',
          'relatedInfoLabel1',
          'relatedInfoLabel2',
          'relatedInfoLabel3'
        ]

        // AND
        kw.ands.forEach(k => {
          const kwLength = k.length
          datas = datas.filter(n => {
            let hit = false
            target.forEach(t => {
              if (n[t].toLowerCase().indexOf(k) !== -1) {
                hit = true
                kwPosition.push({'uid':n.uid,'class':t,'start':n[t].toLowerCase().indexOf(k), 'end':kwLength})
              }
            })
            if (hit) {
              return n
            }
          })
        })

        // omit
        kw.omits.forEach(o => {
          const k = o.slice(1)
          datas = datas.filter(n => {
            let hit = false
            target.forEach(t => {
              if (n[t].toLowerCase().indexOf(k) !== -1) {
                hit = true
              }
            })

            if (hit) {
              // do nothing
            } else {
              return n
            }
          }).filter(n => n)
        })
        console.log(`kw:${kw.ands[0]} (${datas.length})`);
        return new Contents(datas)
      }
    }

  /**
   * 検索キーワードの正規化
   * @param  {String} kw 指定された検索キーワード文字列
   * @return {Object.<{ands: Array, omits: Array}>} 正規化した文字列
   */
   normalizeSearchKeywords(k) {
    const kw = k.replace(/\+/g,' ')
    // double quote
    let temp = kw.replace(/\".*?\"/g, '');
    let ands = []
    if (temp) {
      ands = temp.split(' ').filter((n) => {
        return n !== '' && n !== ' ' && n.indexOf('-',0) === -1
      })
    }

    // omit
    let omits = []
    omits = temp.split(' ').map((n) => {
      if (n.indexOf('-',0) !== -1) {
        return n
      }
    }).filter(n => n)

    // and keyword
    temp = kw.match(/\".*?\"/g);
    let quotes = []
    if (temp) {
      quotes = temp.map((n) => {
        return n.replace(/\"/g, '');
      })
    }

    if (quotes.length > 0) {
      Array.prototype.push.apply(ands, quotes);
    }

    return {'ands':ands, 'omits':omits}
   }

   urlizeSearchKeywords(kw) {
    let temp = kw.replace(/　/g,' ')
    temp = temp.replace(/ /g,'+')
    temp = temp.toLowerCase()
   
    return temp
   }
}